import React from "react";
import { useOutletContext } from "react-router-dom";
import ChatInterface from "../components/chat/ChatInterface";

const ChatSession = (props) => {
  const { isMobile, sidebarOpen, setChats, chats, fetchRecentChats } =
    useOutletContext();
  return (
    <ChatInterface
      isMobile={isMobile}
      sidebarOpen={sidebarOpen}
      setChats={setChats}
      chats={chats}
      fetchRecentChats={fetchRecentChats}
    />
  );
};

export default ChatSession;
